import React from "react"

const SectionSummit = () => (
  <section className="social alt">
    <div className="wrap">
      <h2>We host the nation’s only bundled payment summit</h2>
      <div className="summit2">
        <div className="s2-main">
          <span className="s-lbl">
            Bundled Payment and Care Transformation Summit
          </span>
          <p>
            Our 8th Summit brought health system executives, policymakers, and
            researchers to the Harvard Club of Boston in August 2026.
          </p>
          <div className="cms">
            <span className="cms-tag">CMS Innovation Center</span>
            <p>
              <b>Sacha Wolf of the CMS Innovation Center</b>, who works on both
              CJR-X and TEAM, gave her first public talk on CJR-X at our Summit.
            </p>
          </div>
        </div>
        <div className="s2-side s2-tiles">
          <a
            className="s2-tile t-event"
            href="https://summit.avantgardehealth.com/"
            target="_blank"
            rel="noopener"
          >
            <div className="st-ic">
              <svg
                viewBox="0 0 32 32"
                aria-hidden="true"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="5" y="7" width="22" height="20" rx="3" />
                <path d="M5 13h22M11 4v6M21 4v6" />
                <path d="M11 18h3M18 18h3M11 22h3" />
              </svg>
            </div>
            <div className="st-body">
              <span className="st-kicker">
                Harvard Club of Boston, August 2026
              </span>
              <b>Explore the Summit</b>
              <span>Speakers, agenda, and sessions</span>
            </div>
            <span className="st-go">
              <svg viewBox="0 0 16 16" aria-hidden="true">
                <path
                  d="M6 3h7v7M13 3L5 11"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </a>{" "}
          <a
            className="s2-tile t-rec"
            href="https://resources.avantgardehealth.com"
            target="_blank"
            rel="noopener"
          >
            <div className="st-play">
              <svg viewBox="0 0 32 32" aria-hidden="true">
                <path d="M12 9.5v13l11-6.5z" fill="currentColor" />
              </svg>
            </div>
            <div className="st-body">
              <span className="st-kicker">Recordings and slides</span>
              <b>Request access to session recordings</b>
              <span>Watch the sessions on demand</span>
            </div>
            <span className="st-go">
              <svg viewBox="0 0 16 16" aria-hidden="true">
                <path
                  d="M6 3h7v7M13 3L5 11"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </a>
        </div>
      </div>
    </div>
  </section>
)

export default SectionSummit
